"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.workPackageRequestInputSchema = exports.workPackageRequestSchema = exports.workPackageRequestStatusSchema = exports.WORK_PACKAGE_REQUEST_STATUSES = void 0;
const zod_1 = require("zod");
const common_js_1 = require("./common.js");
const organisation_js_1 = require("./organisation.js");
exports.WORK_PACKAGE_REQUEST_STATUSES = ['offen', 'freigegeben', 'abgelehnt'];
exports.workPackageRequestStatusSchema = zod_1.z.enum(exports.WORK_PACKAGE_REQUEST_STATUSES);
exports.workPackageRequestSchema = zod_1.z.strictObject({
    id: common_js_1.idSchema,
    tenantId: organisation_js_1.tenantSchema.shape.id,
    projectId: common_js_1.idSchema,
    name: common_js_1.textSchema,
    fachgruppeId: common_js_1.idSchema,
    leistungsphase: common_js_1.leistungsphaseSchema,
    assignedEmployeeId: common_js_1.idSchema.nullable(),
    planHours: common_js_1.hoursSchema,
    deadline: common_js_1.dateSchema.nullable(),
    note: zod_1.z.string().optional(),
    requestedById: common_js_1.idSchema,
    status: exports.workPackageRequestStatusSchema,
    createdAt: common_js_1.timestampSchema,
});
exports.workPackageRequestInputSchema = exports.workPackageRequestSchema.pick({
    projectId: true,
    name: true,
    fachgruppeId: true,
    leistungsphase: true,
    assignedEmployeeId: true,
    planHours: true,
    deadline: true,
    note: true,
});
//# sourceMappingURL=requests.js.map